// extracted by mini-css-extract-plugin
module.exports = {"MinMaxDimensionsFeature":"vv_a bgu_b bgu_ux"};